import React, { useEffect, useRef, useState } from 'react';
import styles from './progressBar.module.css';

const SHOW_AFTER_MS = 500;
const FADE_OUT_MS = 250;
const ASYMPTOTE = 92;

export default function ProgressBar({ active }) {
	const [progress, setProgress] = useState(0);
	const [visible, setVisible] = useState(false);
	const showTimer = useRef(null);
	const fadeTimer = useRef(null);
	const tickTimer = useRef(null);

	useEffect(() => {
		const clearAll = () => {
			if (showTimer.current) clearTimeout(showTimer.current);
			if (fadeTimer.current) clearTimeout(fadeTimer.current);
			if (tickTimer.current) clearInterval(tickTimer.current);
		};

		if (active) {
			clearAll();
			showTimer.current = setTimeout(() => {
				setProgress(8);
				setVisible(true);
				tickTimer.current = setInterval(() => {
					setProgress(p => (p < ASYMPTOTE ? p + (ASYMPTOTE - p) * 0.08 : p));
				}, 120);
			}, SHOW_AFTER_MS);
			return clearAll;
		}

		clearAll();
		if (visible) {
			setProgress(100);
			fadeTimer.current = setTimeout(() => {
				setVisible(false);
				setProgress(0);
			}, FADE_OUT_MS);
		}
		return clearAll;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [active]);

	if (!visible) return null;

	return (
		<div className={styles.track}>
			<div
				className={styles.bar}
				style={{ width: `${progress}%`, opacity: progress >= 100 ? 0 : 1 }}
			/>
		</div>
	);
}
